import { themes } from './themes';
import { getColorsMap } from './colors-map';
export const mapTheme = (variables) => {
    return getColorsMap(variables);
};
export const applyTheme = (theme) => {
    const themeObject = mapTheme(themes[theme]);
    if (!themeObject)
        return;
    const root = document.documentElement;
    Object.keys(themeObject).forEach((property) => {
        if (property === 'name') {
            return;
        }
        root.style.setProperty(property, themeObject[property]);
    });
};
export const extend = (extending, newTheme) => {
    return Object.assign(Object.assign({}, extending), newTheme);
};
